import Swiper from 'swiper';

import SwiperCore, { Navigation, Pagination } from 'swiper';

SwiperCore.use([Navigation, Pagination]);

export function initSlider(container, args = {}) {
    return new Swiper(container, Object.assign({}, {
        slidesPerView: 'auto',
        centerInsufficientSlides: true,
        spaceBetween: 20,
        navigation: {
            prevEl: container.parentElement?.querySelector('.swiper-button-prev'),
            nextEl: container.parentElement?.querySelector('.swiper-button-next'),
        },
    }, args));
}
